import { Box, Button, Flex, Text, VStack } from "@chakra-ui/react";
import Link from "next/link";
import { useRouter } from "next/router";

const CTA = () => {
  const router = useRouter();
  const CTALinks = [
    {
      title: "Company",
      links: [
        { title: "Team", link: "/team" },
        { title: "Events", link: "/events" },
      ],
    },
    {
      title: "Help",
      links: [
        { title: "Privacy Policy", link: "/privacy-policy" },
        { title: "Code of Ethics", link: "/code-of-ethics" },
      ],
    },
    {
      title: "Links",
      links: [
        { title: "Resources", link: "/resources" },
        { title: "Blog", link: "/blog" },
      ],
    },
    {
      title: "Contact Info",
      links: [{ title: "info@advante.co", link: "#" }],
    },
  ];
  return (
    <Flex
      direction={"column"}
      align={"center"}
      justify={"center"}
      px={{ xl: "160px", lg: "24px", base: "16px" }}
      py={{ xl: "100px", lg: "80px" }}
      pt={{ base: "64px" }}
      pb={{ base: "32px" }}
      color="white"
      bgColor={"#0D3050"}
      fontFamily={"'Inter', sans-serif"}
    >
      <Flex
        border="1px solid rgba(240, 237, 236, 0.2)"
        p={{ lg: "40px", base: "24px" }}
        borderRadius={"8px"}
        boxShadow={
          "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)"
        }
        mb={{ lg: "64px", base: "40px" }}
        maxW={{ xl: "1120px" }}
        gap={{ xl: "245px", lg: "100px", base: "24px" }}
        justify={{ lg: "space-between", base: "unset" }}
        direction={{ lg: "row", base: "column" }}
      >
        <Flex direction={"column"} align={"start"} gap={{ lg: "12px", base: "8px" }}>
          <Text
            fontFamily={"Georgia"}
            fontSize={"32px"}
            lineHeight={"36px"}
            letterSpacing={{ xl: "-0.015em", lg: "-0.015em", base: "-0.02em" }}
          >
            Start your free complimentary coaching session!
          </Text>
          <Text
            fontSize={{ xl: "18px", lg: "16px", base: "16px" }}
            lineHeight={{ xl: "28px", lg: "24px", base: "24px" }}
            letterSpacing={"0.02em"}
          >
            Join our coaching session and start growing with over 200+ people who have already taken
            the step towards personal development.
          </Text>
        </Flex>
        <Box>
          <Button
            bgColor={"#F9D209"}
            w={{ lg: "132px", base: "full" }}
            py={{ base: "14px" }}
            fontSize={"20px"}
            lineHeight={"20px"}
            color="#0D3050"
            onClick={() => router.push("https://calendly.com/advante/free-coaching")}
          >
            Talk to us
          </Button>
        </Box>
      </Flex>

      <Flex
        justify={{ lg: "space-between", base: "unset" }}
        flexWrap={"wrap"}
        align="start"
        w="full"
      >
        {CTALinks.map((cta) => {
          return (
            <Box key={cta.title} maxWidth={{ lg: "226px", base: "159px" }} w={"full"}>
              <Text
                fontSize={"20px"}
                lineHeight={"20px"}
                mb={{ lg: "32px", base: "16px" }}
                textAlign={"left"}
              >
                {cta.title}
              </Text>
              <VStack align={"start"} spacing={{ lg: "12px", base: "12px" }}>
                {cta.links.map((links, idx) => {
                  return (
                    <Text
                      as={Link}
                      key={links.title}
                      href={`${links.link}`}
                      fontSize={"18px"}
                      lineHeight={"18px"}
                      color="rgba(240, 237, 236, 0.8)"
                      pb={{ base: idx === 1 ? "32px" : "2px" }}
                      borderBottom={"2px solid transparent"}
                      _hover={{
                        color: "white",
                        textDecoration: "underline",
                      }}
                      {...(cta.title === "Contact Info" && {
                        _hover: {
                          color: "rgba(240, 237, 236, 0.8)",
                          textDecoration: "unset",
                          cursor: "unset",
                        },
                      })}
                    >
                      {links.title}
                    </Text>
                  );
                })}
              </VStack>
            </Box>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default CTA;
